import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { HomeComponent } from './home.component';
import { HomeCardsComponent } from './home-cards/home-cards.component';
import { SharedModule } from 'app/shared/shared.module';

@NgModule({
    declarations: [
        HomeComponent,
        HomeCardsComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        RouterModule
    ]
})
export class HomeModule { }
